var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "wizard" } },
    [
      _c(
        "v-stepper",
        {
          model: {
            value: _vm.currentStep,
            callback: function($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "wizard-header",
              class: {
                "header-underline": _vm.currentStep === 6 || _vm.isMobile
              }
            },
            [
              _c(
                "v-container",
                [
                  !_vm.isMobile
                    ? [
                        _c(
                          "v-stepper-header",
                          [
                            _vm._l(_vm.wizardItems, function(item, index) {
                              return _c(
                                "v-stepper-step",
                                {
                                  key: index + 1,
                                  class: [
                                    _vm.isStepDisabled(index)
                                      ? "stepper-disabled"
                                      : ""
                                  ],
                                  attrs: {
                                    "edit-icon": "mdi-circle",
                                    "complete-icon": "mdi-check",
                                    complete: _vm.currentStep > index + 1,
                                    step: index + 1
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.stepClick(index + 1)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(index) +
                                      ". " +
                                      _vm._s(item.title) +
                                      " "
                                  )
                                ]
                              )
                            }),
                            _c("v-divider")
                          ],
                          2
                        )
                      ]
                    : [
                        _vm.wizardItems.length > 0 && _vm.currentStep > 0
                          ? _c(
                              "v-row",
                              {
                                staticClass: "px-4 py-6 ma-0",
                                staticStyle: { gap: "16px" },
                                attrs: { "no-gutters": "" }
                              },
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", md: "12" } },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0",
                                        staticStyle: { gap: "8px" }
                                      },
                                      _vm._l(
                                        _vm.wizardItems.length - 1,
                                        function(index) {
                                          return _c(
                                            "v-col",
                                            {
                                              key: index,
                                              staticStyle: {
                                                padding: "0 !important"
                                              }
                                            },
                                            [
                                              _c("v-progress-linear", {
                                                key: index,
                                                staticStyle: {
                                                  height: "6px",
                                                  "border-radius": "4px"
                                                },
                                                attrs: {
                                                  value: _vm.getStep(index)
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "wizard-header-section",
                                    attrs: { cols: "12" }
                                  },
                                  [
                                    _c(
                                      "v-expansion-panels",
                                      [
                                        _c(
                                          "v-expansion-panel",
                                          [
                                            _c("v-expansion-panel-header", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "wizard-header-section-header"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "wizard-header-section-header-krok"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Krok " +
                                                          _vm._s(
                                                            _vm.currentStep - 1
                                                          ) +
                                                          "/" +
                                                          _vm._s(
                                                            _vm.wizardItems
                                                              .length - 1
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "wizard-header-section-header-title"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.wizardItems[
                                                              _vm.currentStep -
                                                                1
                                                            ].formTitle
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]),
                                            _c(
                                              "v-expansion-panel-content",
                                              [
                                                _c("v-divider", {
                                                  staticClass: "mt-2"
                                                }),
                                                _c(
                                                  "v-list",
                                                  { attrs: { dense: "" } },
                                                  [
                                                    _c(
                                                      "v-list-item-group",
                                                      {
                                                        attrs: {
                                                          value:
                                                            _vm.currentStep - 1,
                                                          color: "primary"
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm.wizardItems,
                                                        function(item, index) {
                                                          return _c(
                                                            "v-list-item",
                                                            {
                                                              key: index + 1,
                                                              class: [
                                                                _vm.isStepDisabled(
                                                                  index
                                                                )
                                                                  ? "stepper-disabled"
                                                                  : ""
                                                              ],
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.stepClick(
                                                                    index + 1
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    {
                                                                      class:
                                                                        index +
                                                                          1 <
                                                                        _vm.currentStep
                                                                          ? "wizard-header-section-list-complete"
                                                                          : index +
                                                                              1 ==
                                                                            _vm.currentStep
                                                                          ? "wizard-header-section-list-active"
                                                                          : ""
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            index
                                                                          ) +
                                                                          ". " +
                                                                          _vm._s(
                                                                            item.title
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                      index +
                                                                        1 <
                                                                      _vm.currentStep
                                                                        ? _c(
                                                                            "v-icon",
                                                                            {
                                                                              staticClass:
                                                                                "wizard-header-section-list-icon-complete"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  "mdi-check"
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : index +
                                                                            1 ==
                                                                          _vm.currentStep
                                                                        ? _c(
                                                                            "v-icon",
                                                                            {
                                                                              staticClass:
                                                                                "wizard-header-section-list-icon-active"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  "mdi-circle"
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "v-icon",
                                                                            {
                                                                              staticStyle: {
                                                                                "font-size":
                                                                                  "0px"
                                                                              }
                                                                            }
                                                                          )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                ],
                2
              )
            ],
            1
          ),
          _c(
            "v-stepper-items",
            { ref: "wizardStepperItems" },
            _vm._l(_vm.wizardItems, function(item, index) {
              return _c(
                "v-stepper-content",
                { key: index, staticClass: "pa-0", attrs: { step: item.step } },
                [
                  item.isAlive
                    ? [
                        _c(item.formName, {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isStepDisabled(index),
                              expression: "!isStepDisabled(index)"
                            }
                          ],
                          ref: item.step,
                          refInFor: true,
                          tag: "component",
                          attrs: {
                            mainTabStep: _vm.currentStep,
                            currentControl: _vm.currentForm,
                            controlName: item.formName,
                            title: item.formTitle
                          },
                          on: {
                            validationChanged: _vm.handleValidationChanged,
                            setCustomButton: _vm.handleSetCustomButton,
                            setCustomButtonSecondary:
                              _vm.handleSetCustomButtonSecondary,
                            dirtyChanged: function(val) {
                              return _vm.dirtyChanged(item, val)
                            },
                            formControlsLoaded: function($event) {
                              return _vm.formControlsLoaded(item, index)
                            },
                            somethingIsLoadingChanged: function(val) {
                              return _vm.somethingIsLoadingChanged(item, val)
                            },
                            loadingOverlayChanged:
                              _vm.handleWizardLoadingOverlayChanged,
                            predmetSelected: _vm.onPredmetSelect,
                            setNotAliveComponent: _vm.setNotAliveComponent,
                            modelyVerzieChanged: _vm.handleModelyVerzieChanged
                          }
                        })
                      ]
                    : _vm._e()
                ],
                2
              )
            }),
            1
          ),
          _vm.showFooter
            ? _c(
                "div",
                { ref: "wizardFooter", staticClass: "wizard-footer" },
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-row",
                        { attrs: { align: "center" } },
                        [
                          _c(
                            "v-col",
                            {
                              style: _vm.debug ? { display: "flex" } : "",
                              attrs: { cols: "12", md: "5" }
                            },
                            [
                              _vm.wizardValidation.message.text ||
                              _vm.wizardValidation.showProgress
                                ? _c(
                                    "span",
                                    [
                                      _vm.wizardValidation.message.text
                                        ? _c("span", {
                                            class: {
                                              negative500:
                                                _vm.wizardValidation.message
                                                  .isError,
                                              bold:
                                                _vm.wizardValidation.message
                                                  .isError,
                                              notError: !_vm.wizardValidation
                                                .message.isError
                                            },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.wizardValidation.message
                                                  .text
                                              )
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.wizardValidation.showProgress
                                        ? _c("v-progress-circular", {
                                            staticClass: "ml-20px",
                                            attrs: {
                                              indeterminate: "",
                                              color: "primary"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.debug
                                ? _c("ul", [
                                    _c("li", [
                                      _vm._v("OBC: " + _vm._s(_vm.pripad.cislo))
                                    ]),
                                    _c("li", [
                                      _vm._v(
                                        "NEW_ID: " + _vm._s(_vm.pripad.newId)
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ml-md-auto",
                              attrs: { md: "auto", cols: "12" }
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "wizard-footer-buttons",
                                  attrs: { "no-gutters": "", align: "center" }
                                },
                                [
                                  _vm.customButtonSecondary.visible
                                    ? _c(
                                        "v-col",
                                        { attrs: { md: "auto", cols: "12" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "btn-secondary",
                                              attrs: { large: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.customButtonSecondary.onClick()
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "break-word" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm
                                                          .customButtonSecondary
                                                          .text
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  !_vm.customButtonSecondary.visible
                                    ? _c(
                                        "v-col",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.currentStep > 1 &&
                                                !_vm.isWizardSumar &&
                                                !_vm.isStepDisabled(
                                                  _vm.currentStep - 2
                                                ),
                                              expression:
                                                "currentStep > 1 && !isWizardSumar && !isStepDisabled(currentStep - 2)"
                                            }
                                          ],
                                          attrs: { md: "auto" }
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "btn-secondary",
                                              attrs: { large: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.stepClick(
                                                    _vm.currentStep - 1
                                                  )
                                                }
                                              }
                                            },
                                            [_c("span", [_vm._v(" Späť ")])]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.customButton.visible
                                    ? _c(
                                        "v-col",
                                        { attrs: { md: "auto", cols: "12" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "btn-primary",
                                              attrs: {
                                                large: "",
                                                disabled: !_vm.customButton
                                                  .enabled
                                              },
                                              on: {
                                                click: _vm.customButton.onClick
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "break-word" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.customButton.text
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  !_vm.customButton.visible
                                    ? _c(
                                        "v-col",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                !_vm.isWizardSumar &&
                                                _vm.currentStep <
                                                  _vm.wizardItems.length,
                                              expression:
                                                "!isWizardSumar && currentStep < wizardItems.length"
                                            }
                                          ],
                                          attrs: { md: "auto" }
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "btn-primary",
                                              attrs: {
                                                large: "",
                                                disabled: !_vm.wizardValidation
                                                  .valid
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.stepClick(
                                                    _vm.currentStep + 1
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(" Pokračovať "),
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: { right: "", dark: "" }
                                                },
                                                [_vm._v(" arrow_right_alt ")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm.modifikujeOperator && _vm.modifikujeOperator !== this.user.login
        ? _c(
            "v-container",
            { staticClass: "mt-100px" },
            [
              _c("v-card", { staticClass: "card" }, [
                _c("h2", [_vm._v("Upozornenie")]),
                _c("br"),
                _vm.jeDealer
                  ? _c("span", { staticClass: "f18" }, [
                      _vm._v(" Obchodný prípad "),
                      _c("span", { staticClass: "bold primary500" }, [
                        _vm._v(_vm._s(_vm.cisloObchPripadu))
                      ]),
                      _vm._v(" je aktuálne modifikovaný operátorom "),
                      _c("span", { staticClass: "bold" }, [
                        _vm._v(_vm._s(_vm.modifikujeOperator))
                      ]),
                      _vm._v(". ")
                    ])
                  : _c("span", { staticClass: "f18" }, [
                      _vm._v(" Obchodný prípad "),
                      _c("span", { staticClass: "bold primary500" }, [
                        _vm._v(_vm._s(_vm.cisloObchPripadu))
                      ]),
                      _vm._v(" je aktuálne modifikovaný iným používateľom. ")
                    ])
              ])
            ],
            1
          )
        : _vm._e(),
      _vm.nemaPravoEditovat
        ? _c(
            "v-container",
            { staticClass: "mt-100px" },
            [
              _c("v-card", { staticClass: "card" }, [
                _c("h2", [_vm._v("Upozornenie")]),
                _c("br"),
                _c("span", { staticClass: "f18" }, [
                  _vm._v(" Nemáte právo editovať obchodný prípad "),
                  _c("span", { staticClass: "bold primary500" }, [
                    _vm._v(_vm._s(_vm.cisloObchPripadu))
                  ]),
                  _vm._v(". ")
                ])
              ])
            ],
            1
          )
        : _vm._e(),
      !_vm.maStredisko
        ? _c(
            "v-container",
            { staticClass: "mt-100px" },
            [
              _c("v-card", { staticClass: "card" }, [
                _c("h2", [_vm._v("Upozornenie")]),
                _c("br"),
                _c("span", { staticClass: "f18" }, [
                  _vm._v(
                    " Nie je možné vytvoriť nový obchodný prípad. Nemáte nastavené stredisko. "
                  )
                ])
              ])
            ],
            1
          )
        : _vm._e(),
      _vm.rozpracovanySumar
        ? _c(
            "v-container",
            { staticClass: "mt-100px" },
            [
              _c("v-card", { staticClass: "card" }, [
                _c("h2", [_vm._v("Upozornenie")]),
                _c("br"),
                _c("span", { staticClass: "f18" }, [
                  _vm._v(
                    " Na rozpracovanom prípade nie je možné zobraziť sumár. Prípad najskôr prosím dokončite. "
                  )
                ])
              ])
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.saveDialogWithEmail,
            callback: function($$v) {
              _vm.saveDialogWithEmail = $$v
            },
            expression: "saveDialogWithEmail"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "dialog-card" },
            [
              _c(
                "v-card-title",
                {
                  staticClass: "d-flex justify-space-between dialog-title-close"
                },
                [
                  _c("span", [_vm._v(" Uložiť ponuku a odoslať na e-mail ")]),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.closeSaveDialogWithEmail()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "gs100" },
                [
                  _c(
                    "v-form",
                    {
                      ref: "saveCloseDialogForm",
                      attrs: { autocomplete: "off" }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          " Ponuku si môžete odoslať na vašu e-mailovú adresu a neskôr sa k nej vrátiť. "
                        )
                      ]),
                      _c("br"),
                      _vm.urlMemorandum.length > 0
                        ? _c("a", { attrs: { href: _vm.urlMemorandum } }, [
                            _vm._v("Informácia o spracúvaní osobných údajov.")
                          ])
                        : _vm._e(),
                      _c("text-box", {
                        staticClass: "mt-10px",
                        attrs: {
                          label: "Zadajte e-mailovú adresu",
                          isEnabled: true,
                          required: true,
                          rules: [
                            function(v) {
                              return (
                                _vm.emailRegex.test(v) ||
                                !_vm.saveEmail ||
                                !v ||
                                "Nesprávny formát e-mailovej adresy"
                              )
                            }
                          ],
                          hideRequired: ""
                        },
                        model: {
                          value: _vm.saveEmail,
                          callback: function($$v) {
                            _vm.saveEmail = $$v
                          },
                          expression: "saveEmail"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-primary",
                      on: {
                        click: function($event) {
                          return _vm.checkEmail()
                        }
                      }
                    },
                    [_vm._v(" Odoslať ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-overlay",
        {
          attrs: {
            color: "#000",
            opacity: "0.40",
            value: _vm.loadingRefi.loading,
            "z-index": 5
          }
        },
        [
          _c(
            "v-card",
            {
              staticClass: "text-center mt-n100px card",
              attrs: { width: "500" }
            },
            [
              _c("v-progress-circular", {
                staticClass: "mb-20px",
                attrs: {
                  indeterminate: "",
                  color: "primary",
                  size: 25,
                  width: 2
                }
              }),
              _c("text-group", {
                attrs: {
                  invert: "",
                  large: "",
                  utext: _vm.loadingRefi.text,
                  btext: "Upozornenie",
                  gap: 20
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-overlay",
        {
          attrs: {
            color: "#000",
            opacity: "0.40",
            value:
              _vm.somethingIsLoading ||
              (!_vm.editInitialized && !_vm.loadingRefi.loading) ||
              _vm.sumarLoading ||
              _vm.sendMail ||
              _vm.wizardLoadingOverlay.loading,
            "z-index": 6
          }
        },
        [
          _c("v-progress-circular", {
            staticClass: "mr-10px",
            attrs: {
              indeterminate: "",
              color: "primary",
              size: _vm.isMobile ? 30 : 60,
              width: 5
            }
          }),
          !_vm.sendMail
            ? [_vm._v(" Prebieha načítanie dát, prosím počkajte ... ")]
            : [_vm._v(" Odosielanie emailu, prosím počkajte ... ")]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }